@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled" [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition)}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span [matTooltipPosition]="'below'"
                [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
            <i class="mdi mdi-help-circle tooltip-icon"></i>
          </span>
        }
      </div>
      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)" tabindex="0"
             [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition, 'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}">
          <span>{{ getFieldValue() | fieldFormatType: fieldConfig.customOptions?.formatType | emptyFieldPipe: {blankFieldValue: appConfig.EMPTY_FIELD_VALUE} }}</span>
          @if (fieldConfig.suffixType) {
            <span>{{ fieldConfig.suffixType | translate }}</span>
          }
          @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
            <span
              class="overlay-icon">
              @if (preconditionsForEdition) {
                <i class="mdi mdi-pencil selectable"></i>
              } @else {
                <i [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate"
                   class="mdi mdi-pencil-off tooltip-icon"></i>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled" class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span [matTooltipPosition]="'below'"
                  [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
              <i class="mdi mdi-help-circle tooltip-icon"></i>
            </span>
          }
        </div>
      }
      <div #fieldContainer class="field-container fx-flex-100-66-percent-min-500 fx-layout-col">
        @defer (when fieldContainer.offsetWidth) {
          <form autocomplete="off" [formGroup]="form">
            <mat-form-field appearance="outline">
              <mat-label>{{ fieldConfig.label }}</mat-label>
              <input #inputField formControlName="field" [matAutocomplete]="auto" matInput type="text"
                     [required]="fieldConfig.customOptions?.required"
                     (keyup.escape)="onEscapeCancel($event)"
                     (keyup.enter)="onActivate($event)">
              @if (fieldConfig.suffixType) {
                <span matTextSuffix>{{ fieldConfig.suffixType | translate }}</span>
              }
              @if (isCreatingEntity && fieldConfig.tooltip) {
                <span matTextSuffix matTooltipPosition="below"
                      [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
                  <i class="mdi mdi-help-circle tooltip-icon"></i>
                </span>
              }
              @for (validator of erroredValidators; track validator.type) {
                <mat-error>
                  {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                </mat-error>
              }
              <mat-autocomplete #auto="matAutocomplete" [panelWidth]="fieldContainer.offsetWidth-90">
                @for (fieldValue of filteredOptions | async; track fieldValue) {
                  <mat-option [value]="fieldValue">{{ fieldValue }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </form>
        }
        @if (isSingleField) {
          <div class="save-options">
            <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
              <i class="mdi mdi-close"></i>
            </button>
            <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)" [disabled]="!form.valid"
                    class="button save">
              <i class="mdi mdi-check"></i>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
